import { Radio, type RadioGroupProps } from 'antd';
import { type FormItemProps } from 'antd/es/form';
import { useField } from 'formik';
import React, { memo } from 'react';
import FormItem from './FormItem';

type RadioGroupOptions<T> = {
    label: string;
    value: T;
    disabled?: boolean;
};

export type RadioGroupFieldProps<T extends Omit<RadioGroupProps, 'value' | 'onChange' | 'autoComplete'>> = {
    name: string;
    defaultValue?: any;
    label?: string;
    required?: boolean;
    options: RadioGroupOptions<T>[];
    disabled?: boolean;
    tooltip?: FormItemProps['tooltip'];
};

const RadioGroupField = <T,>({ name, required, label, tooltip, options, ...props }: RadioGroupFieldProps<T>) => {
    const [field, meta] = useField({ name });

    return (
        <FormItem label={label} meta={meta} required={required} tooltip={tooltip}>
            <Radio.Group
                // spread props
                {...props}
                // then spread the field properties itself
                {...field}
            >
                {options.map(({ label, ...optionProps }, index) => (
                    // eslint-disable-next-line react/no-array-index-key
                    <Radio.Button key={index.toString()} {...optionProps}>
                        {label}
                    </Radio.Button>
                ))}
            </Radio.Group>
        </FormItem>
    );
};

export default memo(RadioGroupField);
